<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { Skeletor } from 'vue-skeletor';

export default defineComponent({
	name: 'ListItemSkeleton',
	components: { Skeletor },

	setup(props) {
		const { t } = useI18n({ useScope: 'global' });

		return {
			...props,
			t,
		};
	},
});
</script>

<template>
	<div class="apoc-list-item">
		<div class="apoc-list-img-wrapper">
			<div class="img-cover">
				<Skeletor class="apoc-list-img-skeleton" />
			</div>
		</div>
		<div class="apoc-list-info-wrapper">
			<div class="apoc-list-info-profile">
				<Skeletor class="apoc-list-profile-skeleton" />
			</div>
			<div class="apoc-list-info-wrapper">
				<div class="apoc-list-info-title">
					<h6>
						<Skeletor />
					</h6>
				</div>
				<div class="apoc-list-info-sub">
					<div class="apoc-list-info-desc">
						<p>
							<Skeletor />
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped></style>
